import React from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Done as CheckIcon } from "@mui/icons-material";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: ${({ size }) => size}px;
`;

const LabelWrapper = styled.div`
  margin-right: 8px;
  opacity: 0.9;
  font-family: Roboto;
  font-size: 12px;
  line-height: 1.17;
  text-align: left;
  color: #747576;
`;

const borderSize = 0;
const Checkbox = styled.div`
  width: ${({ size }) => size - 2 * borderSize}px;
  height: ${({ size }) => size - 2 * borderSize}px;
  border-radius: 6px;
  background-color: #f6f6f6;
  border: ${borderSize}px solid #c6c6c6;
  box-sizing: content-box;
  & .MuiSvgIcon-root {
    font-size: ${({ size }) => size - 2 * borderSize}px;
    color: ${({ checked }) => (checked ? "#222" : "#f6f6f6")};
  }
`;

const ReadOnlyCheckbox = (props) => {
  const {
    checked,
    color = "#f6f6f6",
    loadingMainColor = "#ccc",
    loadingSecondaryColor = "#fff",
    label,
    loading,
    size = 32,
  } = props;

  return (
    <>
      {loading && (
        <Skeleton
          height={size}
          baseColor={loadingMainColor}
          highlightColor={loadingSecondaryColor}
        />
      )}
      {!loading && (
        <Wrapper size={size}>
          <>
            <LabelWrapper>{label}</LabelWrapper>
            <Checkbox size={size} checked={checked}>
              <CheckIcon />
            </Checkbox>
          </>
        </Wrapper>
      )}
    </>
  );
};

export default ReadOnlyCheckbox;
